import styles from './Typography.module.scss';
import React, { DOMAttributes, FC } from 'react';
import csx from 'classnames';

interface Props extends DOMAttributes<unknown> {
  variant?: 'paragraph' | 'h1' | 'h2' | 'h3' | 'h4' | 'error' | 'pageTitle';
  element?: 'p' | 'h2' | 'h3' | 'h4' | 'span' | 'div' | 'a' | 'label';
  classes?: string;
  color?: string | 'primary' | 'secondary';
  fontWeight?: 'normal' | 'bold' | 'black';
  fontSize?: 'tiny' | 'small' | 'medium' | 'large' | 'xlarge';
  effect?: 'gradient' | 'gradient-box';
}

const Typography: FC<Props> = React.forwardRef(function TypographyComponent(
  {
    variant = 'paragraph',
    element = 'p',
    children,
    classes,
    color,
    fontWeight,
    fontSize,
    effect,
    ...props
  },
  ref
) {
  const className = csx(styles.host, classes, styles[variant], {
    [styles[fontSize]]: !!fontSize,
    [styles[fontWeight]]: !!fontWeight,
    [styles.primary]: color === 'primary',
    [styles.secondary]: color === 'secondary',
    [styles.gradientEffect]: effect === 'gradient',
    [styles.gradientBoxEffect]: effect === 'gradient-box',
  });

  return React.createElement(
    element,
    {
      ref,
      className: `${className}`,
      ...(color && { style: { color } }),
      ...props,
    },
    children
  );
});

export default Typography;
